/*
 * Authors: mariushirjanu
 * Created: 17/01/2023
 */
import { Component, Input, Output, OnChanges, EventEmitter, SimpleChanges } from '@angular/core';
import { LogLevel, RemoteLoggerDataService } from '../../../../shared/services/logger/remote-logger-data.service';
import { IObject } from '../../../../../type_definitions/datatypes';
import { GaMessageService } from '../../../../shared/message/ga-message.service';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { util } from '../../../../shared/util';

@Component({
  selector: 'punchout-catalog',
  template: `
    <form id="punchoutForm" method="POST" [action]="safeUrl" target="punchoutIframe" [innerHTML]="safeMessage" style="display:none"></form>
    <iframe name="punchoutIframe" id="punchoutIframe" (load)="onLoad()" marginheight="0" marginwidth="0"></iframe>
  `
})
export class PunchoutCatalogComponent implements OnChanges {
  @Input() public protocol:string;
  @Input() public url:string;
  @Input() public message:string;
  @Output() public onLoading:EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public onPunchoutTransfer:EventEmitter<IObject> = new EventEmitter<IObject>();

  public safeMessage:SafeHtml;
  public safeUrl:SafeResourceUrl;
  public firstLoad:boolean = true;

  constructor(
    private messageService:GaMessageService,
    private domSanitizer:DomSanitizer,
    private remoteLoggerDataService:RemoteLoggerDataService
  ) {
    /***/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes?.url) {
      this.url = changes.url.currentValue;
      this.safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.url);
    }

    if (changes?.message) {
      this.message = changes.message.currentValue;
      this.safeMessage = this.domSanitizer.bypassSecurityTrustHtml(this.message);
    }
    if (changes?.protocol) {
      this.protocol = changes.protocol.currentValue;
    }
    // init iframe
    this.initIframe();
  }

  private initIframe = ():void => {
    if (this.url && this.message && this.protocol === 'OCI') {
      this.updateForm();
    } else {
      this.clearFormIframe();
    }
  };

  private updateForm():void {
    // set form inputs, activity indicator and submit form
    this.onLoading.emit(true);
    this.submitForm();
  }

  public onLoad():void {
    this.onLoading.emit(false);
    this.tryGetPunchoutCartContents();
    this.firstLoad = false;
  }

  // submit the form having as target the iframe
  private submitForm():void {
    // wait a whole for the form inputs to be set into DOM before to submit the form
    setTimeout(() => {
      $('form#punchoutForm').submit();
    }, 0);
  }

  // clear the form inputs and remove the iframe content
  private clearFormIframe():void {
    this.safeUrl = undefined;
    this.safeMessage = undefined;
    $('iframe#punchoutIframe').attr('src', 'about:blank');
  }

  // get cart items from iframe content and bind as JSON outside the component
  private tryGetPunchoutCartContents():void {
    let documentElement:HTMLElement;
    try {
      documentElement = (<HTMLIFrameElement>$('#punchoutIframe')[ 0 ]).contentWindow.document.documentElement;
      $(documentElement).find('body > pre').hide(); // hide the block <pre> where the json resides
      const punchoutData:IObject = this.getJsonFromDocument(documentElement);
      console.debug('Punchout data found:', punchoutData);

      if (punchoutData.status === 'OK' && punchoutData.data && punchoutData.data.extCurrency && punchoutData.data.items && punchoutData.data.items.length > 0) {
        this.onPunchoutTransfer.emit(punchoutData.data);
      } else if (punchoutData.status === 'FAIL' && punchoutData.message) {
        this.messageService.showErrorMessage(punchoutData.message);
      }

      // re-init iframe
      this.initIframe();
    } catch (e) {
      /**/
    }
  }

  private getJsonFromDocument(documentElement:HTMLElement) {
    try {
      return util.fromJson($(documentElement).text());
    } catch (e) {
      // sometimes the html is changed by a browser extension => try getting the text from the body tag
      try {
        return util.fromJson($(documentElement).find('body').text());
      } catch (e) {
        // finally, if parsing fails, we log it to the server
        if (!this.firstLoad && $('iframe#punchoutIframe').attr('src') !== 'about:blank') {
          const msg:IObject = {
            message: 'Error reading punchout message from html',
            error: e,
            html: $(documentElement).html()
          };
          this.remoteLoggerDataService.remoteLog(msg, LogLevel.ERROR);
          console.error(util.toJson(msg));
        }
        throw e;
      }
    }
  }
}